import { render } from "./RegisterButton.vue?vue&type=template&id=2d1edc56&scoped=true"
import script from "./RegisterButton.vue?vue&type=script&lang=js"
export * from "./RegisterButton.vue?vue&type=script&lang=js"

import "./RegisterButton.vue?vue&type=style&index=0&id=2d1edc56&lang=scss"
import "./RegisterButton.vue?vue&type=style&index=1&id=2d1edc56&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1edc56"]])

export default __exports__
import QResponsive from 'quasar/src/components/responsive/QResponsive.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import TouchHold from 'quasar/src/directives/touch-hold/TouchHold.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QResponsive,QMenu,QList,QItem,QItemSection,QSeparator,QIcon,QBtn,QImg,QBadge});qInstall(script, 'directives', {ClosePopup,TouchHold});
